import React, {
  useState,
  useContext,
  useImperativeHandle,
  forwardRef,
} from 'react'

import TimeIcon from 'Assets/Images/icons/time'
import NoTimeIcon from 'Assets/Images/icons/noTime'

import { SnackBarContext } from 'Components/SnackBar'

import {
  StyledWrapper,
  StyledSubTitle,
  StyledButtonsWrapper,
  StyledButtonContainer,
  StyledRadioContainer,
  StyledRadioCenter,
} from './styles'

import {
  CONVERSION_REPORT_TYPE,
  CONVERSION_REPORT_TYPE_SHOW,
} from '../../../../../../shared/constants'

const SelectReportType = (
  { type = CONVERSION_REPORT_TYPE.NO_TYPE, existConversions = true },
  ref,
) => {
  const [reportType, setReportType] = useState(type)
  const runSnackBar = useContext(SnackBarContext)

  useImperativeHandle(ref, () => ({
    reportType,
  }))

  const handleChangeReportType = type => {
    if (existConversions) {
      runSnackBar({
        type: 'error',
        vertical: 'top',
        msg:
          'All conversions must be deleted before the report type can be changed.',
      })
      return
    }
    setReportType(type)
  }

  const selectReportTypeButton = type => (
    <StyledButtonContainer
      isSelected={reportType === type}
      onClick={() => handleChangeReportType(type)}
    >
      <StyledRadioContainer>
        <StyledRadioCenter />
      </StyledRadioContainer>
      {type === CONVERSION_REPORT_TYPE.WITH_TIMESTAMP ? (
        <TimeIcon />
      ) : (
        <NoTimeIcon />
      )}
      <StyledSubTitle isMarginLeft>
        {CONVERSION_REPORT_TYPE_SHOW[type]}
      </StyledSubTitle>
    </StyledButtonContainer>
  )

  return (
    <StyledWrapper>
      <StyledSubTitle>
        Please, set the report type for this campaign:
      </StyledSubTitle>
      <StyledButtonsWrapper>
        {selectReportTypeButton(CONVERSION_REPORT_TYPE.WITH_TIMESTAMP)}
        {selectReportTypeButton(CONVERSION_REPORT_TYPE.WITHOUT_TIMESTAMP)}
      </StyledButtonsWrapper>
    </StyledWrapper>
  )
}

export default forwardRef(SelectReportType)
